exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "adp-definition-list section{width:100%}adp-definition-list h4{font-family:ProximaNova-Bold,Arial,Helvetica,sans-serif;color:#000}adp-definition-list dl{color:#4a4a4a;font-family:ProximaNova-Regular,Arial,Helvetica,sans-serif;font-size:14px}adp-definition-list dt{font-size:15px}adp-definition-list dd{margin-bottom:5px;color:#000;font-family:ProximaNova-Semibold,Arial,Helvetica,sans-serif}adp-definition-list dd:last-of-type{margin-bottom:0}adp-definition-list dd .ico{display:inline-block}@media only screen and (max-width:779px){adp-definition-list [class*=grid-][class*=-bottom]{align-items:flex-start}adp-definition-list dt{margin-bottom:5px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/components/adpDefinitionList/adpDefinitionList.less
// module id = 516
// module chunks = 0